<script setup>
import { computed, normalizeClass, useAttrs } from 'vue';
import { Spinner as PolarisSpinner } from 'next/polaris/ui/spinner';

// The woot's spinner API (size in px) over the kit's spinner. A caller that sizes it with a class (`size-3`,
// the Button's `!w-4 !h-4`) keeps that size; otherwise `size` applies. An inline size would beat a plain class,
// so it is only set when the caller gives none.
const props = defineProps({
  size: {
    type: Number,
    default: 24,
  },
});

defineOptions({ inheritAttrs: false });
const attrs = useAttrs();

const SIZED = /(^|\s|!)(size|w|h)-/;
const sizedByCaller = computed(() => SIZED.test(normalizeClass(attrs.class)));
const sizeStyle = computed(() =>
  sizedByCaller.value
    ? undefined
    : { width: `${props.size}px`, height: `${props.size}px` }
);
</script>

<template>
  <PolarisSpinner v-bind="attrs" :style="sizeStyle" />
</template>
